import isBookingTimeValid from "./isBookingTimeValid";
import slotSupportsPeople from "./slotSupportsPeople";
import { isPast } from "../../dependencies/utils";
import type { AvailabilitySlot } from "../../model/types";

export type AvailabilitySlotStatusProperties = Pick<
  AvailabilitySlot,
  "open" | "available" | "time" | "cutOffTime" | "dinersAvailable"
>;

type AvailabilitySlotStatus = "closed" | "sold" | "unavailable" | "available";

export default function getAvailabilitySlotStatus(
  slot: AvailabilitySlotStatusProperties,
  people?: number | null,
): AvailabilitySlotStatus {
  if (slot.open === false) {
    return "closed";
  }

  if (isPast(slot.cutOffTime)) {
    return "unavailable";
  }

  if (!slot.time || !isBookingTimeValid(slot.time)) {
    return "sold";
  }

  if (people && slot.dinersAvailable && slot.dinersAvailable.length > 0) {
    return slotSupportsPeople(slot.dinersAvailable, people)
      ? "available"
      : "unavailable";
  }

  return slot.available ? "available" : "unavailable";
}
